module.exports = __webpack_public_path__ + "static/bedroom-8bf82bf767755cc6f69687601a0036ae.jpg";